import { GaTrackingEventCategory } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';

export class BackToCartApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.BackToCart;

  getPayload(): any {
    return {
      label: 'Back to cart clicked',
      gtmCustom: {
        category: GaTrackingEventCategory.Interaction,
      }
    };
  }
}
